/* ++++++++++ --------------- HELP PAGE : STYLES --------------- ++++++++++ */

export default theme => ({
    CustomLink: {
        color: '#5CB3FF'
    },
    SearchBar: {
        width: '125%',
        marginLeft: '50px',
        '& .categoryselector': {
            width: '300px'
        }
    },
    FilterMenuCustom: {
        '& .selectablelist': {
            overflow: 'hidden',
            height: '11em'
        }
    },
    ListTableCustom: {
        '& .listtable': {
            border: 'solid 1px #E7E7E7',
            padding: '0px 0px 15px 0px',
            '& .head': {
                fontSize: '0.95em',
                borderBottom: 'solid 1px #E7E7E7'
            }
        }
    },
    Controls: {
        padding: '10px',
        border: 'solid 1px #E7E7E7',
        backgroundColor: 'white'
    }
});